import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormGroup,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useCallback } from "react";
import TypographyCompo from "../../../components/Comman/TypographyCompo";
import { dueToStockShortageOfferIsNotApplicableMsg } from "../../../config/messageconstant";

const OfferCheckboxCardItem = ({ applicableOfferData, onCheckBoxClick }) => {
	const handleChange = useCallback(() => {
		onCheckBoxClick(applicableOfferData, applicableOfferData.appliedOfferId);
	}, [onCheckBoxClick, applicableOfferData]);

	return (
		<div
			className={`offer-card${
				applicableOfferData.isApplied == 1 ? " offer-card--selected" : ""
			}${
				applicableOfferData.isApplied === 2 ? " offer-card--disabled" : ""
			}`}
		>
			<FormControl component="fieldset" fullWidth>
				<FormGroup aria-label="position" row>
					<FormControlLabel
						value="end"
						control={
							<Checkbox
								checked={applicableOfferData.isApplied == 1}
								onChange={handleChange}
								disabled={applicableOfferData.isApplied === 2}
							/>
						}
						label={
							<TypographyCompo component="span">
								{applicableOfferData.name}
							</TypographyCompo>
						}
						labelPlacement="end"
					/>
				</FormGroup>
				{applicableOfferData.isApplied !== 2 ? (
					<TypographyCompo className="offer-card-description">
						{applicableOfferData.discription}
					</TypographyCompo>
				) : (
					<TypographyCompo className="offer-card-error">
						{dueToStockShortageOfferIsNotApplicableMsg}
					</TypographyCompo>
				)}
			</FormControl>
		</div>
	);
};

OfferCheckboxCardItem.propTypes = {
	applicableOfferData: PropTypes.object.isRequired,
	onCheckBoxClick: PropTypes.func.isRequired,
};

export default React.memo(OfferCheckboxCardItem);
